
define(
	'Code25.CaterpartsGlobal.DeliveryCosts.View'
	, [
		"Handlebars", "Utils", "Code25.deliverycosts.tpl", "Tools", 'js.cookie', 'LiveOrder.Model'
	]
	, function (
		Handlebars, Utils, Code25_deliverycosts_tpl, Tools, Cookies, LiveOrderModel
	) {
		'use strict';


		var slideIn

		return Backbone.View.extend({

			template: Code25_deliverycosts_tpl,
			initialize: function (options) {



			},
			getContext: function getContext() {

				var model = LiveOrderModel.getInstance();
				var subtotal = model.get("summary").subtotal || 0;
				// console.log(subtotal);
				var extra = Math.max(0, 250 - subtotal);
				return {
					isFree: subtotal >= 250
					, extra: Utils.formatCurrency(extra)
				};
			}
		});

	});



